import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';

const EventSummaryCard = ({ title, location, price, onView, minWidth = { xs: 200, sm: 240, md: 260 }, maxWidth = { xs: 1, sm: 320, md: 340 }, height = '100%' }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        minWidth,
        maxWidth,
        bgcolor: 'background.paper',
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: 0,
        p: { xs: 2, sm: 3 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height,
        border: `1px solid ${theme.palette.divider}`,
        mr: { xs: 1, sm: 2 },
        flex: 1,
      }}
      aria-label="Event summary"
    >
      <Box>
        <Typography variant="overline" color="text.secondary" sx={{ mb: 1 }}>
          {location || 'CIVIC CENTER, MANHATTAN'}
        </Typography>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 2, wordBreak: 'break-word' }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary">
          Starts at {price}
        </Typography>
        <Button
          variant="contained"
          size="small"
          sx={{
            borderRadius: theme.shape.borderRadius * 2,
            ml: 2,
            background: 'linear-gradient(90deg, #7B61FF 0%, #4F8FFF 100%)',
            color: '#fff',
            fontWeight: 600,
            textTransform: 'none',
            px: 3,
            boxShadow: 'none',
            '&:hover': {
              background: 'linear-gradient(90deg, #4F8FFF 0%, #7B61FF 100%)',
              boxShadow: 'none',
            },
          }}
          onClick={onView}
          aria-label="View event details"
        >
          View
        </Button>
      </Box>
    </Box>
  );
};

export default EventSummaryCard; 